import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'

import {
	getCurrentUser
} from 'state/selectors'

import moment from 'moment'

import AlertBanner from 'components/alerts/alert-banner'
import copy from 'fast-copy'

class DoughnutChart extends Component {
	options = null

	data = null
	legendData = null

	UNSAFE_componentWillMount = _ => {
		this.options = {
			responsive: true,
			maintainAspectRatio: false,
			onHover: data => {
			},
			tooltips: {
				callbacks: {
					title: (tooltipItem, data) => {
						const index = tooltipItem[0].index
						const title = data.labels[0][index]

						return title
					},
					label: (tooltipItem, data) => {
						const index = tooltipItem.index
						const hours = data.datasets[0].data[index]
						const word = this.props.type == 'status' ? 'task' : 'hour'

						let response = hours+' '+word

						if(hours > 1){
							response += 's'
						}

						return response
					}
				},
				titleFontColor: '#000',
				bodyFontColor: '#17c68c',
				backgroundColor: '#fff',
				displayColors: false
			},
			legend: {
				display: false,
			},
			cutoutPercentage: 65,
			animation: {
				animateRotate: true
			}
		}
	}

	formatColours = (chartData, legendData) => {
		const {
			isDataFake,
			userData
		} = this.props

		let newChartData = copy(chartData)
		let newLegendData = copy(legendData)

		if(!isDataFake){
			let shouldOverwriteColours = !chartData.datasets[0].backgroundColor.length

			if(shouldOverwriteColours){
				const accentRgb = window.isTkb ? {
					r: 147,
					g: 203,
					b: 102
				} : {
					r: 23,
					g: 198,
					b: 140
				}

				newLegendData.forEach((legendRow, index) => {
					const colour = {
						r: Math.round((accentRgb.r) * (1 - (index/10))),
						g: Math.round((accentRgb.g) * (1 - (index/10))),
						b: Math.round((accentRgb.b) * (1 - (index/10))),
					}

					const colourString = `rgb(${colour.r}, ${colour.g}, ${colour.b})`

					newLegendData[index].colour = colourString
					newChartData.datasets[0].backgroundColor[index] = colourString
					newChartData.datasets[0].hoverBackgroundColor[index] = colourString
				})
			}

			if(newChartData.datasets[0].lastAsEmpty){
				const grey = userData.show_dark_ui ? '$lightBg' : '#f5f5f5'
				newChartData.datasets[0].backgroundColor.push = grey
				newChartData.datasets[0].hoverBackgroundColor.push = grey
			}

		}else{
			let greysArray = ['rgba(0,0,0,0.35)','rgba(0,0,0,0.25)','rgba(0,0,0,0.15)']

			if(userData.show_dark_ui){
				greysArray = ['rgba(255,255,255,0.6)', 'rgba(255,255,255,0.5)', 'rgba(255,255,255,0.4)']
			}

			newChartData.datasets[0].backgroundColor = greysArray
			newChartData.datasets[0].hoverBackgroundColor = greysArray
		}

		return {
			chart: newChartData,
			legend: newLegendData
		}
	}

	render() {
		const {
			isDataFake,
			meta,
			data,
			thisUser,
			legendData,
			type,
			showLegend,
			loading,
		} = this.props

		const emptyCopy = this.props.emptyCopy ? this.props.emptyCopy : {
			title: ``,
			body: ``
		}

		this.data = this.formatColours(data, legendData)

		let className = "doughnut-chart"

		if(loading){
			className += ' loading'
		}

		const displayString = {
			title: type == 'status' ? this.data.chart.datasets[0].totalItems : `${Math.round(meta.totalTracked)}/${meta.totalWorked}`,
			subtitle: type == 'status' ? 'tasks' : 'hours'
		}

		return (
			<div className={className}>
				{ loading &&
					<Loader visible={loading} />
				}
				<div className={isDataFake ? "doughnut no-events" : "doughnut"}>
					{ !isDataFake ?
						<div className="hours-display">
							<h3>
								{ displayString.title }
							</h3>
							<span>
								{ displayString.subtitle }
							</span>
						</div>
					: null }
					<Doughnut 
						data={this.data.chart} 
						options={this.options} 
					/>
				</div>
				{ showLegend &&
					<div className="legend">
						{ isDataFake ?
							<AlertBanner
								title={emptyCopy.title} 
								body={emptyCopy.body}
							/>
							:
							<ul>
								{ this.data.legend.map(project => {
									const duration = moment.duration(project.seconds, 'seconds')

									const days = duration.days()
									const hoursString = duration.hours() + (days * 24)
									const minutesString = duration.minutes()

									return (
										<li key={project.name}>
											<i style={{
												background: project.colour
											}} />
											<span>
												{ project.name }:
												<em>
													{ hoursString }{ hoursString !== 1 ? ' hrs ' : ' hr ' } { minutesString ? minutesString : null}{ minutesString ? minutesString !== 1 ? ' mins ' : ' min ' : null}
													({ project.percent+'%' })
												</em>
											</span>
										</li>
									)
								})}
							</ul>
						}
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state)
	}
}

export default connect(mapStateToProps, {})(DoughnutChart)